
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMoreVerticalGoogle as ObiMoreVerticalGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-more-vertical-google.js';
 
 
 

 
 export const ObiMoreVerticalGoogle = createComponent({
   react: React,
   tagName: 'obi-more-vertical-google',
   elementClass: ObiMoreVerticalGoogleElement,
   events: {
     
   }
  });
 
 